import React, { useEffect, useState } from 'react';
import { BgLogin, TicketNotFound } from './ViewAllTickets.style';
import { useMutation, useQuery } from 'react-query';
import ClientsTickets from 'components/support/view-all-tickets/ViewAllTickets';
import { LOGIN_TO_PORTAL } from 'components/support/queries';

const ViewAllTickets = () => {
  const filterBy = window.location.hash.split('filter_by=')[1];
  const endPoint = window.location.hash.includes('filter_by')
    ? `/admin/tickets?filter_by=${filterBy}`
    : '/admin/tickets';

  const { data: getTickets, isLoading, isFetching: loadingTickets, isError } = useQuery(`${endPoint}`);
  const { data: getSubStatus } = useQuery('/admin/tickets/substatus/definitions');
  const { data: getDeparment } = useQuery('/admin/tickets/department/definitions');
  const { mutate: loginToPortal, isLoading: loadingUrl } = useMutation(LOGIN_TO_PORTAL);
  const [pageSize, setPageSize] = useState(100);

  const handlePortalLogin = async (portal, user) => {
    await loginToPortal(
      {
        portal: portal,
        user: user,
      },
      {
        onSuccess: (e) => {
          window.open(e.redirect_url, '_blank');
        },
      },
    );
  };

  useEffect(() => {
    // const interval = setInterval(() => getTicketsRefetch(), 5 * 1000);
    // return () => clearInterval(interval);
    setPageSize(100);
  }, [endPoint]);

  return (
    <BgLogin>
      {isError ? (
        <TicketNotFound>Ticket not found</TicketNotFound>
      ) : (
        <ClientsTickets
          pageSize={pageSize}
          setPageSize={setPageSize}
          loadingUrl={loadingUrl}
          handlePortalLogin={handlePortalLogin}
          getDeparment={getDeparment}
          getTickets={getTickets || isLoading}
          loadingTickets={loadingTickets}
          getSubStatus={getSubStatus}
          endPoint={endPoint}
        />
      )}
    </BgLogin>
  );
};

export default ViewAllTickets;
